// linq.js is vendored — no compatible npm package exists for ES modules.
// The vendored file assigns to window.Enumerable.
import '../vendor/linq.js';
export const Enumerable = (window as any).Enumerable;
